import BackButton from "@src/components/_shared/BackButton";
import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import useNavigationStore from "@src/stores/navigationStore";
import useRegistrationStore from "@src/stores/registrationStore";
import { useMutation, useQuery } from '@tanstack/react-query';
import { getReferencialData } from '@src/api/Referencial';
import CountryDropdown from '@src/components/_shared/UI/CountryDropdownList';
import { Form, Formik } from 'formik';
import Input from '@src/components/_shared/UI/Input';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import { personUpdate } from '@src/api/Registration';
import Loader from '@src/components/_shared/UI/Loader';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { Toaster } from 'react-hot-toast';
import { handleApiError } from "@src/utilities/functions";

export default function Nationality() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();

    const { data, isLoading } = useQuery({
        queryKey: [`getCountriesData`],
        queryFn: () => getReferencialData({type: 'countries'})
    })

    const { data: LEINationalitiesData, isLoading: LEINationalitiesLoading } = useQuery({ 
        queryKey: [`countriesWithNid`], 
        queryFn: () => getReferencialData({type: 'countries/with-nid'})
    });

    const { mutate, isPending } = useMutation({
        mutationFn: (value: any) => personUpdate({key: 'legal', value, is_psi: registration.partner_informations.is_partner, person_id: registration.person_id}), 
        onSuccess: () => {
            setSection(3)
            setBlock('CompanyMisc')
        },
        onError: (error: any) => handleApiError(error)
    });

    const textByCountry = (code: string) => {
        let textToShow
        Object.entries(LEINationalitiesData).forEach(([key, value]) => {
            if (code === key) {
                textToShow = value;
            }
        });
        return textToShow
    }

    const _onGoBack = () => {
        setSection(2)
        setBlock('LegalCapacity')
    };

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Nationalité" />
            <Subtitle content="Votre nationalité doit être la même que sur votre document d’identité officiel" />
            {isLoading || LEINationalitiesLoading ? <Loader type='SPINNER' /> : null}
            {data && LEINationalitiesData ?
                <Formik
                    initialValues={{
                        national_id: registration.person.legal.national_id,
                        nationality: registration.person.legal.nationality,
                    }}
                    onSubmit={(values) => {
                        setField('person.legal', {
                            ...registration.person.legal,
                            national_id: values.national_id,
                            nationality: values.nationality
                        })
                        mutate({legal_capacity: registration.person.legal.legal_capacity, national_id: values.national_id, nationality: values.nationality})
                    }}
                >
                    {({ handleChange, handleSubmit, values, setFieldValue }) => {
                        const hasLEINationality = Object.keys(LEINationalitiesData).includes(values.nationality)
                        return (
                            <Form id="nationalIdForm" autoComplete="off" className="registerForm">
                                <CountryDropdown
                                    title="Sélectionnez un pays"
                                    width="100%"
                                    options={data}
                                    selected={registration.person.legal.nationality}
                                    onSelect={handleChange('nationality')}
                                />
                                {hasLEINationality ?
                                    <Input
                                        title={textByCountry(values.nationality)}
                                        width="100%"
                                        value={values.national_id}
                                        onChange={handleChange('national_id')}
                                        placeholder="Code"
                                        clearInput={() => handleChange('national_id')('')}
                                        id="national_id"
                                        type="text"
                                    />
                                    : null}
                                <ValidateButton onClick={handleSubmit} title="Continuer" disabled={isPending || hasLEINationality ? (!values.nationality || !values.national_id) : !values.nationality } onLoading={isPending} />
                            </Form>
                        )
                    }}
                </Formik>
                : null}
            <Toaster/>
        </Container>
    )
}
